<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: { ContentLoader },
  props: {
    primaryColor: {
      type: String,
      default: '#F9FAFF',
    },
    secondaryColor: {
      type: String,
      default: '#D8DFF6',
    },
  },
};
</script>

<template>
  <content-loader
    width="316"
    height="437"
    viewBox="0 0 316 437"
    :speed="2"
    :primaryColor="primaryColor"
    :secondaryColor="secondaryColor"
    :primaryOpacity="0.9"
    :secondaryOpacity="0.25"
  >
    <rect x="88" y="78" width="152" height="20" rx="4" />
    <rect x="88" y="155" width="152" height="20" rx="4" />
    <rect x="88" y="232" width="152" height="20" rx="4" />
    <rect x="88" y="309" width="152" height="20" rx="4" />
    <rect x="88" y="386" width="152" height="20" rx="4" />
    <rect x="24" y="11" width="152" height="33" rx="4" />
    <circle cx="47" cy="88" r="23" />
    <circle cx="47" cy="165" r="23" />
    <circle cx="47" cy="242" r="23" />
    <circle cx="47" cy="319" r="23" />
    <circle cx="47" cy="396" r="23" />
  </content-loader>
</template>
